import React, { useContext, useEffect, useState } from 'react';
import { CABS_SEO_AD_CONTEXT_ID } from '../constants/adsConfig';
import { ifAdsPresent } from '../utils/adsUtils';
import { Context } from '../AppContext';
import { pageLoadedInBrowser } from '../utils/commonUtils';

const BrowserAdComponent = ({ uuid }) => {
  if (pageLoadedInBrowser()) {
    try {
      const AdComponent = require('ad-react-wrapper').default;
      return <AdComponent uuid={uuid} />;
    } catch (e) {
      console.log('Error in loading Ad:', e);
    }
  }
  return null;
};

type AdsConfig = {
  position: string;
  class: string;
  style: any;
};
type AdsComponentProp = {
  template: string;
  placedAt: string;
  isMobileDevice: boolean;
  desktopAdConfig: AdsConfig;
  mobileAdConfig: AdsConfig;
};
const AdsComponent = ({
  template,
  placedAt,
  isMobileDevice,
  desktopAdConfig,
  mobileAdConfig
}: AdsComponentProp) => {
  const { trackTemplateEvent } = useContext(Context);

  return (
    <>
      {isMobileDevice
        ? (() =>
            mobileAdConfig.position && mobileAdConfig.position === placedAt ? (
              <div style={{ height: '90px' }} className={'appendBottom10'}>
                <div className={'makeFlex perfectCenter'}>
                  <div
                    style={mobileAdConfig.style}
                    // className={mobileAdConfig.class}
                    onClick={() => {
                      if (ifAdsPresent())
                        trackTemplateEvent(
                          `Mob_Cab_SEO_${template}_Template_Ad_Clicked`
                        );
                    }}
                  >
                    <BrowserAdComponent uuid={CABS_SEO_AD_CONTEXT_ID} />
                  </div>
                </div>
              </div>
            ) : null)()
        : (() =>
            desktopAdConfig.position &&
            desktopAdConfig.position === placedAt ? (
              <div style={{ height: '90px' }} className={'appendBottom10'}>
                <div className={'makeFlex perfectCenter'}>
                  <div
                    style={desktopAdConfig.style}
                    // className={desktopAdConfig.class}
                    onClick={() => {
                      if (ifAdsPresent())
                        trackTemplateEvent(
                          `Cab_SEO_${template}_Template_Ad_Clicked`
                        );
                    }}
                  >
                    <BrowserAdComponent uuid={CABS_SEO_AD_CONTEXT_ID} />
                  </div>
                </div>
              </div>
            ) : null)()}
    </>
  );
};

export default AdsComponent;
